import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';
import { SET_PIP_CANVAS_EL, SET_PIP_EVENTS, SET_PIP_LOCAL_VIDEO_EL, SET_PIP_MAIN_VIDEO_EL, SET_PIP_RAISED_HANDS, SET_PIP_REQUEST_ANIM_ID, SET_PIP_SIZES, SET_PIP_STATUS, SET_PIP_STREAM_TO_LOCAL_VIDEO_EL, SET_PIP_STREAM_TO_MAIN_VIDEO_EL, SET_PIP_TILE_VIEW_CANVASES, SET_PIP_TILE_VIEW_LIST, SET_PIP_VIRTUAL_VIDEO_EL, UPDATE_USER_IN_TILE_VIEW_LIST } from './actionTypes';
import { STATUSES } from './constants';
const DEFAULT_STATE = {
    isPipEventsEmitted: false,
    requestAnimationId: null,
    pipStatus: STATUSES.NOT_STARTED,
    mainVideo: null,
    videoTrackStore: null,
    localVideoElement: null,
    canvasEl: null,
    canvasCtx: null,
    virtualVideoEl: null,
    videoMuted: null,
    audioMuted: null,
    listUsersRaisedHands: [],
    tileViewMaxUsers: 5,
    tileViewList: {},
    tileCanvases: [],
    dimensions: {
        width: 0,
        height: 0,
        localVideoWidth: 0,
        localVideoHeight: 0,
        localVideoX: 0,
        localVideoY: 0
    }
};
ReducerRegistry.register('wildix/features/PiP', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_PIP_EVENTS:
            return {
                ...state,
                isPipEventsEmitted: action.isPipEventsEmitted
            };
        case SET_PIP_SIZES:
            return {
                ...state,
                dimensions: action.dimensions
            };
        case SET_PIP_REQUEST_ANIM_ID:
            return {
                ...state,
                requestAnimationId: action.requestAnimationId
            };
        case SET_PIP_STATUS:
            return {
                ...state,
                pipStatus: action.pipStatus
            };
        case SET_PIP_CANVAS_EL:
            return {
                ...state,
                canvasEl: action.canvasEl,
                canvasCtx: action.canvasCtx
            };
        case SET_PIP_VIRTUAL_VIDEO_EL:
            return {
                ...state,
                virtualVideoEl: action.virtualVideoEl
            };
        case SET_PIP_STREAM_TO_MAIN_VIDEO_EL: {
            const mainVideo = state.mainVideo;
            if (mainVideo) {
                mainVideo.srcObject = action.srcObject;
            }
            return {
                ...state,
                ...mainVideo,
                videoTrackStore: action.jitsiTrack
            };
        }
        case SET_PIP_STREAM_TO_LOCAL_VIDEO_EL: {
            const localVideoElement = state.localVideoElement;
            if (localVideoElement) {
                localVideoElement.srcObject = action.srcObject;
            }
            return {
                ...state,
                ...localVideoElement
            };
        }
        case UPDATE_USER_IN_TILE_VIEW_LIST:
            return {
                ...state,
                tileViewList: {
                    ...state.tileViewList,
                    [action.id]: { ...state.tileViewList[action.id],
                        ...action.newData }
                }
            };
        case SET_PIP_MAIN_VIDEO_EL:
            return {
                ...state,
                mainVideo: action.mainVideo
            };
        case SET_PIP_LOCAL_VIDEO_EL:
            return {
                ...state,
                localVideoElement: action.localVideoElement
            };
        case SET_PIP_TILE_VIEW_LIST:
            return {
                ...state,
                tileViewList: action.tileViewList
            };
        case SET_PIP_TILE_VIEW_CANVASES:
            return {
                ...state,
                tileCanvases: action.tileCanvases
            };
        case SET_PIP_RAISED_HANDS:
            return {
                ...state,
                listUsersRaisedHands: action.listUsersRaisedHands
            };
    }
    return state;
});
